import Grid from "@mui/material/Grid";
import ListItem from "@mui/material/ListItem";
import Box from "@mui/material/Box";
import NavBar from "../../../../modules/molecules/navbar/main";
import { useDispatch, useSelector } from "react-redux";
import { toggleSidebar } from "../../../../store/panel_slice";
import ProfileAccordian from "./components/profileAccordian/main";
import ToggleButton from "./components/toggle/main";
import { stateType } from "../../../../store/store.type";
import { List, Skeleton, useMediaQuery } from "@mui/material";
import { useEffect } from "react";

const Sidebar = ({ sidePanelOpen }: { sidePanelOpen: boolean }) => {
  const dispatch = useDispatch();

  const mouseHandler = () => {
    // return;
    dispatch(toggleSidebar({ panelOpen: !sidePanelOpen }));
  };
  const { fullName } = useSelector(
    (sel: stateType) => sel.userProfileSlice.data,
  );
  const isSmallScreen = useMediaQuery("@media(max-width:712px)");
  useEffect(() => {
    if (isSmallScreen) {
      dispatch(toggleSidebar({ panelOpen: false }));
    }
  }, [isSmallScreen]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        borderRight: "1px solid rgba(0, 0, 0, 0.1)",
        gap: "1rem",
        paddingRight: "10px",
      }}
    >
      <List>
        <ListItem
          disablePadding
          sx={{ display: "block", position: "relative" }}
        >
          <Grid item lg={12}>
            {fullName === "" ? (
              <Skeleton
                variant="circular"
                animation="wave"
                sx={{
                  height: "40px",
                  width: "40px",
                  marginTop: "15px",
                  marginLeft: "8px",
                }}
              />
            ) : (
              <ProfileAccordian expanded={sidePanelOpen} />
            )}
          </Grid>
        </ListItem>
      </List>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "0.5rem",
        }}
      >
        <NavBar />
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        {!isSmallScreen && (
          <Box sx={{ position: "fixed", bottom: 0 }}>
            <ToggleButton
              onClick={mouseHandler}
              disabled={false}
              sidePanelOpen={sidePanelOpen}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};
export default Sidebar;
